<template>
  <div class="gc-status-chip">
    <span
      v-bind:class="{
        active: status == 'N',
        inactive: status == 'Y',
      }"
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.gc-status-chip label {
  padding: 1px 5px;
  min-width: 76px;
}
span {
  display: inline-block;
  width: 1em;
  height: 1em;
  border-radius: 50%;
}

.active {
  background: #62d26f;
}
.inactive {
  background-color: #e8384f;
}
</style>
